import React, { Component } from "react"
import SbEditable from "storyblok-react"
import axios from "axios"
import ImagesService from '../../../utils/images-service'
import Button from "../../Button"

import paypal from "./paypal.svg"
import creditcard from "./creditcard.svg"
import directdebit from "./directdebit.svg"

import "./styles.scss"


class Donate extends Component {
    constructor(props) {
        super(props)
        this.blok = props.blok
    }

    render() {
            return (
                <SbEditable content={this.blok}>
                    <div className="hero-block-splitscreen donate">
                        <div className="container">
                            <div className="text">
                                <h1>{this.blok.headline}</h1>
                                <p>{this.blok.teaser}</p>
                                <div id='betterplace_donation_iframe'><strong><a href='https://www.betterplace.org/de/donate/platform/projects/106543-dein-projekttitel'>Jetzt Spenden für die Gerald-Asamoah-Stiftung bei unserem Partner betterplace.org</a></strong></div>
                            </div>
                            {this.blok.image.filename !== "" &&
                            <div className="image" style={{backgroundImage: `url(${ ImagesService(this.blok.image.filename, true, { path: '900x1400/smart'}) })`}}>
                                <img src={ImagesService(this.blok.image.filename, true, { path: '450x338/smart'})} srcSet={`${ImagesService(this.blok.image.filename, true, { path: '450x338/smart'})} 1x, ${ImagesService(this.blok.image.filename, true, { path: '900x676/smart'})} 2x`} width="450" height="338" />
                            </div>
                            }
                        </div>
                    </div>
                </SbEditable>
            )
    }
}  
  
export default Donate
